export default __webpack_public_path__ + "static/media/beautiful-stories.413d12ce.jpg";